<template>
  <div class="wrapper">
    <admin-title :title="$route.meta.name"></admin-title>
    <div class="content-card">
      <div class="header-search">
        <el-form
            ref="form"
            inline
            :model="searchData"
            label-width="80px"
            size="small"
        >
          <el-form-item label="手机号码">
            <el-input
                v-model="searchData.mobile_like"
                placeholder="请输入"
                clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="下单时间">
            <el-date-picker
                style="width: 240px"
                v-model="searchData.created_at_between"
                type="daterange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <div class="btn-group">
              <el-button
                  type="primary"
                  icon="el-icon-search"
                  @click="getList"
              >搜索
              </el-button>
              <el-button
                  type="info"
                  icon="el-icon-refresh"
                  @click="reset"
              >重置
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
      
      <div class="tabs">
        <div :class="['tab-item', searchData.status === '' ? 'active' : '']" @click="handleClickTab('')">
          <el-badge :value="statistics?.all || 0" :hidden="!statistics?.all">
            <span class="tab-name">全部</span>
          </el-badge>
        </div>
        <div :class="['tab-item', searchData.status === 0 ? 'active' : '']" @click="handleClickTab(0)">
          <el-badge :value="statistics?.pending || 0" :hidden="!statistics?.pending">
            <span class="tab-name">待审核</span>
          </el-badge>
        </div>
        <div :class="['tab-item', searchData.status === 20 ? 'active' : '']" @click="handleClickTab(20)">
          <el-badge :value="statistics?.approved || 0" :hidden="!statistics?.approved">
            <span class="tab-name">通过</span>
          </el-badge>
        </div>
        <div :class="['tab-item', searchData.status === 10 ? 'active' : '']" @click="handleClickTab(10)">
          <el-badge :value="statistics?.rejected || 0" :hidden="!statistics?.rejected">
            <span class="tab-name">拒绝</span>
          </el-badge>
        </div>
      </div>

      <el-table 
          :data="list" 
          v-loading="loading"
          border
          stripe
          style="width: 100%"
          highlight-current-row
      >
        <el-table-column
            prop="pay_file"
            label="支付凭证"
            min-width="120px"
        >
          <template slot-scope="{ row }">
            <div
                class="user-box"
                v-if="row.pay_file"
            >
              <div class="row">
                <a 
                  v-for="item in row.pay_file" 
                  :key="item.name" 
                  :href="item.url" 
                  :download="item.name"
                  class="file-link"
                >
                  <i class="el-icon-document"></i> {{item.name}}
                </a>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
            prop="buyer_remark"
            label="备注"
            min-width="120px"
        >
        </el-table-column>
        <el-table-column
            prop="status_dsc"
            label="状态"
            min-width="80px"
        >
          <template slot-scope="{ row }">
            <el-tag 
              :type="row.status === 20 ? 'success' : row.status === 10 ? 'danger' : 'warning'"
              size="small"
            >
              {{ row.status_dsc }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column
            prop="user"
            label="用户"
            min-width="180px"
        >
          <template slot-scope="{ row }">
            <div class="user-box">
              <div class="row">
                <span>名称：</span>
                <span>{{ row?.user?.nickname || '-' }}</span>
              </div>
              <div class="row">
                <span>号码：</span>
                <span>{{ row?.user?.mobile || '-' }}</span>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column
            prop="created_at"
            label="提交日期"
            min-width="120px"
        ></el-table-column>
        <el-table-column
            label="操作"
            width="150px"
            fixed="right"
        >
          <template slot-scope="{ row }">
            <el-button
                v-if="row.status == 0"
                type="primary"
                size="mini"
                @click="showAuditDialog(row)"
            >审核
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <div class="pagination-container">
        <pagination
            :total="total"
            :page.sync="searchData.page"
            :limit.sync="searchData.pagesize"
            @pagination="getList"
        />
      </div>
    </div>
    
    <el-dialog
        title="审核支付凭证"
        :visible.sync="dialogVisible"
        width="500px"
        :close-on-click-modal="false"
        :before-close="handleClose">
      <el-form ref="form" :model="changeStatusFormData" label-width="100px" size="small">
        <el-form-item label="状态：">
          <el-radio-group v-model="changeStatusFormData.status">
            <el-radio :label="20">同意</el-radio>
            <el-radio :label="10">拒绝</el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-if="changeStatusFormData.status === 20">
          <el-form-item label="支付金额">
            <el-select v-model="changeStatusFormData.pay_price" placeholder="请选择支付金额" style="width: 100%">
              <el-option label="988" :value="988"></el-option>
              <el-option label="1388" :value="1388"></el-option>
              <el-option label="1888" :value="1888"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="到期时间">
            <el-date-picker type="date" placeholder="选择日期" v-model="changeStatusFormData.expire_date"
                            style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item label="子账号数量">
            <el-input v-model="changeStatusFormData.account_num"></el-input>
          </el-form-item>
        </div>
        <el-form-item label="备注：">
          <el-input type="textarea" v-model="changeStatusFormData.audit_remark" rows="3"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="audit()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {getListAPI, getDetailAPI, auditAPI} from './api'
import {authBtnMixin} from '@/mixins/authBtnMixin'
import {addRole} from "@/views/powerManage/role/api"

export default {
  name: 'Index',
  mixins: [authBtnMixin],
  data() {
    return {
      rules: [{required: true, message: '该项不能为空', trigger: 'blur'}],
      show_detail: false,
      show_review: false,
      dialogVisible: false,
      loading: false,
      list: [],
      city_list: [],
      searchData: {
        page: 1,
        pagesize: 10,
        mobile_like: '',
        status: '',
        created_at_between: [],
      },
      total: 0,
      statistics: null,
      changeStatusFormData: {
        id: '',
        status: null,
        audit_remark: '',
        pay_price: 0,
        account_num: 0,
        expire_date: '',
      },
    }
  },
  provide() {
    return {
      context: this
    }
  },
  mounted() {
    this.getList()
  },

  methods: {
    // 详情
    async handleDetail({id}) {
      this.detail = await getDetailAPI(id)
      this.show_detail = true
    },
    handleClose() {
      this.dialogVisible = false
    },
    showAuditDialog({id}) {
      this.changeStatusFormData.id = id
      this.dialogVisible = true
    },
    audit() {
      auditAPI(this.changeStatusFormData).then(() => {
        this.$message.success('审核成功')
        this.dialogVisible = false
        this.getList()
      }).catch(err => {
        this.$message.error('审核失败：' + (err.message || '未知错误'))
      })
    },
    handleClickTab(status) {
      this.searchData.status = status
      this.getList()
    },
    async getList() {
      this.loading = true
      try {
        // 获取get 参数
        let params = {...this.searchData}
        const res = await getListAPI(params)
        this.list = res.data || []
        this.total = res.total || 0
        // 假设API返回了统计数据，如果没有可以注释掉
        this.statistics = res.statistics || {
          all: this.total,
          pending: 0,
          approved: 0,
          rejected: 0
        }
      } catch (error) {
        this.$message.error('获取数据失败：' + (error.message || '未知错误'))
      } finally {
        this.loading = false
      }
    },
    reset() {
      Object.assign(this._data.searchData, this.$options.data().searchData)
      this.getList()
    },
    // 导出数据
    exportData() {
      this.$fn.downloadHandle(this.searchData, '/api/api/manage/user/pay_voucher/download', '订单统计报表', 'post')
    },
    // 获取查询字符串
    getQueryString() {
      const query = {...this.searchData}
      return Object.keys(query)
        .filter(key => query[key] !== '' && query[key] !== null && query[key] !== undefined)
        .map(key => {
          if (Array.isArray(query[key])) {
            return `${key}=${query[key].join(',')}`
          }
          return `${key}=${query[key]}`
        })
        .join('&')
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  background-color: #f5f7fa;
  min-height: calc(100vh - 120px);
  padding: 10px;
  box-sizing: border-box;

  .content-card {
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    padding: 20px;
    margin-bottom: 20px;
  }

  .header-search {
    margin-bottom: 20px;
    
    .el-form /deep/ {
      .el-form-item {
        margin-right: 20px;
        margin-bottom: 15px;
        
        .el-form-item__label {
          font-weight: 500;
        }
      }
      
      .el-input, .el-select, .el-date-editor {
        width: 220px;
      }
    }
    
    .btn-group {
      display: flex;
      gap: 10px;
      
      .el-button {
        padding: 8px 15px;
        transition: all 0.3s;
        
        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
        }
      }
    }
  }

  .tabs {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    border-bottom: 1px solid #dcdfe6;

    .tab-item {
      cursor: pointer;
      position: relative;
      padding: 0 15px 10px;
      margin-right: 25px;
      transition: all 0.3s;
      
      &:hover {
        color: #409eff;
      }

      .tab-name {
        padding: 6px;
        font-size: 14px;
      }
    }

    .active {
      color: #409eff;
      font-weight: 600;

      &::after {
        content: '';
        display: inline-block;
        height: 2px;
        width: 100%;
        background: #409eff;
        position: absolute;
        bottom: 0;
        left: 0;
        border-radius: 2px;
        transition: all 0.3s;
      }
    }
  }
  
  .el-table {
    margin-bottom: 20px;
    border-radius: 4px;
    overflow: hidden;
    
    /deep/ {
      .el-table__header-wrapper th {
        background-color: #f5f7fa;
        color: #606266;
        font-weight: 600;
        height: 50px;
      }
      
      .el-table__row {
        transition: all 0.3s;
        
        &:hover {
          background-color: #f0f9ff !important;
        }
      }
    }
  }
  
  .pagination-container {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
  }
  
  .file-link {
    display: inline-flex;
    align-items: center;
    margin-right: 10px;
    color: #409eff;
    text-decoration: none;
    transition: all 0.3s;
    
    &:hover {
      color: #66b1ff;
      text-decoration: underline;
    }
    
    i {
      margin-right: 5px;
    }
  }
}
</style>

<style lang="scss" scoped>
.wrapper /deep/ {
  /* switch按钮样式 */
  .switch .el-switch__label {
    position: absolute;
    display: none;
    color: #fff !important;
  }

  /*打开时文字位置设置*/
  .switch .el-switch__label--right {
    z-index: 1;
  }

  /* 调整打开时文字的显示位子 */
  .switch .el-switch__label--right span {
    margin-left: 5px;
    margin-right: 10px;
  }

  /*关闭时文字位置设置*/
  .switch .el-switch__label--left {
    z-index: 1;
  }

  /* 调整关闭时文字的显示位子 */
  .switch .el-switch__label--left span {
    margin-left: 20px;
  }

  /*显示文字*/
  .switch .el-switch__label.is-active {
    display: block;
  }

  /* 调整按钮的宽度 */
  .switch.el-switch .el-switch__core,
  .el-switch .el-switch__label {
    width: 70px !important;
    margin: 0;
  }
  
  /* 对话框样式优化 */
  .el-dialog {
    border-radius: 8px;
    overflow: hidden;
    
    .el-dialog__header {
      background-color: #f5f7fa;
      padding: 15px 20px;
      border-bottom: 1px solid #e4e7ed;
    }
    
    .el-dialog__body {
      padding: 20px;
    }
    
    .el-dialog__footer {
      border-top: 1px solid #e4e7ed;
      padding: 15px 20px;
    }
  }
}
</style>

<style lang="scss" scoped>
.icon-box /deep/ {
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 108px;
    height: 108px;
    line-height: 108px;
    text-align: center;
  }

  .avatar {
    width: 108px;
    height: 108px;
    display: block;
  }
}

.user-box {
  .row {
    display: flex;
    margin-bottom: 5px;

    span {
      &:nth-child(1) {
        width: 72px;
        text-align: right;
        color: #909399;
      }

      &:nth-child(2) {
        text-align: left;
        font-weight: 500;
      }
    }
  }
}
</style>
